<mat-card>
  <mat-card-title>
    {{ title }}
  </mat-card-title>
  <mat-card-content>
    <form class="form-horizontal" (submit)="uploadFile()">
      <div class="form-group">
        <label for="customer_import_upload" class="col-sm-2">Datei</label>
        <div class="col-sm-10">
          <input type="file" #fileInput class="form-control" id="customer_import_upload">
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-5">
          <button type="submit" mat-button>importieren</button>
        </div>
        <div class="col-sm-5">
          <mat-progress-spinner *ngIf="isImporting" mode="indeterminate"></mat-progress-spinner>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/settings/file-import/file-import.component.html